module.exports = __webpack_public_path__ + "img/term-of-use-careers.9a91a07e.png";